import React, { Component } from 'react';
// import Header from "../starLight/header"
import Banner from "../starLight/banner"
import Products from "../starLight/products"
import Gallery from "../starLight/gallery"
import ProductDetails from "../starLight/product-deatils"
import About from "../starLight/about"
import Contact from "../starLight/contact"


export default class home extends Component {

  render() {
  
    return (
      <div className='main-wrap-maevelife'>
        {/* <Header/> */}
        <Banner/>
        <Products/>
        <Gallery/>
        <ProductDetails/>
        <About/>
        <Contact/>
      </div>
    )
  }
}
